import { useApesStorageApi } from "@/api/useApesStorageApi";
import { useWeb3Store } from "@/store/web3";
import { web3 } from "@/web3";

const messageToSign =
  "I'm carefully revealing my Clues and won't be sharing them";

export const fetchClues = async (reveal) => {
  let signature;
  const wallet = useWeb3Store().walletAddress;
  if (reveal) {
    console.log("wallet", wallet);
    if (!signature) {
      try {
        signature = await web3.eth.personal.sign(messageToSign, wallet);
      } catch (err) {
        // useToast().error({ title: "Couldn't sign the message" });
        console.error(err);
      }
    }
    if (!signature) return false;
  }

  const data = await useApesStorageApi({
    throw: true,
    toast: { error: true },
  }).exec({
    url: "/wallet/clues",
    params: {
      wallet: wallet,
      ...(reveal && {
        signer: wallet, // wallet that sign the request, if it's not same as sender, safe claim will be checked
        signature, // signature to confirm the request },
        reveal: true, // reveal clues
      }),
    },
  });

  if (!data) return [];

  // data
  //  {
  //     "5": 1,
  //     "23": 1,
  //     "33": 7,
  //     "43": 13,
  //     "1109": 2,
  //     "onChain": {
  //         "2": "1",
  //         "23": "3",
  //         "31": "1",
  //         "33": "8",
  //         "43": "13"
  //     }
  // }
  let result = [];
  Object.keys(data).forEach((key) => {
    if (key === "onChain" || key === "images") return;
    const count = data[key];
    const onChainCount = data.onChain?.[key] || 0;
    const image =
      data.images?.[key] ||
      "https://imagedelivery.net/r12dBNi95K-w7NNZkxF9WQ/ba0fb22c-adea-4401-051e-334654f1c600/original";

    result.push({
      id: key,
      name: `Clue #${key - 100000}`,
      image,
      onChainCount: +onChainCount,
      offChainCount: +count,
      isUtility: true,
      type: "CLUE",
    });
  });

  Object.keys(data.onChain).forEach((key) => {
    if (result.find((item) => item.id === key)) return;
    const count = data.onChain[key];
    const offChainCount = data[key] || 0;
    const image =
      data.images?.[key] ||
      "https://imagedelivery.net/r12dBNi95K-w7NNZkxF9WQ/ba0fb22c-adea-4401-051e-334654f1c600/original";
    result.push({
      id: key,
      name: `Clue #${key - 100000}`,
      image,
      count: +count,
      offChainCount: +offChainCount,
      isUtility: true,
      type: "CLUE",
    });
  });

  return [...result];
};

function loadStackableClue(offchainUtilitiesCount, id, type) {
  const items = [];
  const balanceOnChain = +(offchainUtilitiesCount.onChain?.[id] || 0);
  const balanceOffChain = +(offchainUtilitiesCount[id] || 0);
  const balance = {
    onChain: balanceOnChain,
    offChain: balanceOffChain,
    all: balanceOnChain + balanceOffChain,
  };

  if (balanceOffChain > 0 || balanceOnChain > 0) {
    items.push({
      ...utilitiesMetadata[id],
      id,
      offChainCount: balanceOffChain,
      onChainCount: balanceOnChain,
      isUtility: true,
      type,
    });
  }
  return { items, balance };
}
